import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';
import CustomSelect from '../../../components/widgets/CustomSelect';

/**
 * 하위 메뉴 타입 제어 (상단 배치일 때만)
 * 메가메뉴 / 드롭다운메뉴 선택
 */
const SubmenuTypeControl = () => {
  const themeContext = useTheme();
  if (!themeContext) return null;
  const { themeConfig, set } = themeContext;

  return (
    <div id="submenu-type-control-section" style={{ marginBottom: '20px' }}>
      <div className="submenu-type-control-header" style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
        <label style={{ display: 'block', fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>
          하위 메뉴 타입:
        </label>
        <button
          type="button"
          className="theme-help-btn"
          data-target="submenu-type-control-section"
          title="이 항목으로 이동"
          style={{
            background: 'transparent',
            border: '1px solid #ddd',
            color: '#666',
            fontSize: '11px',
            width: '20px',
            height: '20px',
            padding: 0,
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          ?
        </button>
      </div>
      <CustomSelect
        inputId="submenu-type-selector"
        value={themeConfig.submenuType || 'mega'}
        onChange={(v) => set('submenuType', v)}
        isSearchable={false}
        isClearable={false}
        options={[
          { value: 'mega', label: '메가메뉴' },
          { value: 'dropdown', label: '드롭다운메뉴' },
        ]}
        styles={{
          control: (base, state) => ({
            ...base,
            width: '100%',
            minHeight: 36,
            fontSize: 13,
            borderRadius: 4,
            borderColor: state.isFocused ? '#86b7fe' : '#ddd',
          }),
          valueContainer: (base) => ({ ...base, padding: '0 10px' }),
          indicatorsContainer: (base) => ({ ...base, height: 36 }),
        }}
      />
      <div className="submenu-type-control-description" style={{ fontSize: '11px', color: '#999', marginTop: '6px' }}>
        상단 메뉴에서 1뎁스 항목 클릭/호버 시 하위 메뉴 표시 방식을 선택합니다.
      </div>
    </div>
  );
};

export default SubmenuTypeControl;
